import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { CrntElement } from '../../lib/crnt-element.js';
import { DeepSlotChangeController } from '../../lib/deep-slot-change-controller/deep-slot-change-controller.js';
import { LinkSlottedFormElementsController } from '../../lib/link-slotted-form-elements/link-slotted-form-elements.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class CrntFormControl extends CrntElement {
  constructor() {
    super(...arguments);
    this.disableAutoLink = false;
    this._linkSlottedFormElementsController = new LinkSlottedFormElementsController({
      enabled: false,
      host: this,
      selectors: {
        crntInput: ":not([slot]):is(crnt-text-input,crnt-select)",
        help: '[slot="help"]',
        input: ":not([slot]):is(input,textarea,select)",
        label: '[slot="label"] label',
        validation: '[slot="validation"]'
      }
    });
    this._deepSlotChangeController = new DeepSlotChangeController({
      callback: (mutations) => this._linkSlottedFormElementsController.deepSlotChangeCallback(mutations),
      host: this
    });
  }
  static {
    this.tagName = "crnt-form-control";
  }
  connectedCallback() {
    super.connectedCallback();
    this._linkSlottedFormElementsController.enabled = !this.disableAutoLink;
  }
  render() {
    return html`
			<div part="container">
				<slot @slotchange=${this._handleSlotChange} name="label" part="label"></slot>
				<slot @slotchange=${this._handleSlotChange} name="help" part="help"></slot>
				<slot @slotchange=${this._handleSlotChange} name="validation" part="validation"></slot>
				<slot @slotchange=${this._handleSlotChange} part="control"></slot>
				<slot @slotchange=${this._handleSlotChange} name="actions" part="actions"></slot>
			</div>
		`;
  }
  willUpdate(_changedProperties) {
    super.willUpdate(_changedProperties);
    if (_changedProperties.has("disableAutoLink")) {
      this._linkSlottedFormElementsController.willUpdate();
      this._linkSlottedFormElementsController.enabled = !this.disableAutoLink;
    }
  }
  _handleSlotChange() {
    this._linkSlottedFormElementsController.handleSlotChange();
  }
}
__decorateClass([
  property({ attribute: "disable-auto-link", reflect: true, type: Boolean })
], CrntFormControl.prototype, "disableAutoLink");

export { CrntFormControl };
